if (!customElements.get('ellexa-product-results-slider')) {
  customElements.define(
    'ellexa-product-results-slider',
    class EllexaProductResultsSlider extends HTMLElement {
      connectedCallback() {
        this.sliderEl = this.querySelector('.ellexa-results-slider__swiper');
        this.paginationEl = this.querySelector('.ellexa-results-slider__pagination');
        if (!this.sliderEl || typeof FoxTheme === 'undefined') return;

        this.carousel = new FoxTheme.Carousel(this.sliderEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          threshold: 5,
          pagination: {
            el: this.paginationEl,
            clickable: true,
          },
        });
        this.carousel.init();
      }

      disconnectedCallback() {
        if (this.carousel?.slider) {
          this.carousel.slider.destroy(true, true);
        }
      }
    }
  );
}
